export default __webpack_public_path__ + "static/png-assets-05-f237348ec3a091a6d2dc27697c4326a1.png";